module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-segment-visualisation-middle.2a68e9c7.png";